import * as React from 'react';
import * as styles from './videos-count.module.scss';
import { IconName } from '~/common/enums/enums';
import { FormattedMessage, Icon } from '~/components/common/common';
import { AppLocalizationKey } from '~/common/types/types';

type Props = {
  count: number;
  message: AppLocalizationKey;
};

const VideoCountLabel: React.FC<Props> = ({ count, message }) => (
  <div className={styles.videoCount}>
    <Icon className={styles.videoCountIcon} iconName={IconName.VIDEO} />
    {count}&nbsp;
    <FormattedMessage message={message} />
  </div>
);

export { VideoCountLabel };
